import { Col, Row } from "antd";
import { NicheSendOtp } from "niche-ui-component";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useOrganization } from "../../OrganizationProvider";
import { ROUTES } from "../Common/Constants";
import { userSendOtpUrl } from "../Common/endpoints";
import { MailOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setPhoneNumber } from "../../reducers/authSlice";

const SendOtp = () => {
  const navigate = useNavigate();
  const organization = useOrganization();
  const dispatch = useDispatch();

  const handleSubmit = (response) => {
    dispatch(setPhoneNumber(response?.phoneNumber));
    navigate(ROUTES.VERIFY_OTP.link);
    toast.success(response?.data?.message);
  };
  return (
    <Row justify="center" className="mt1">
      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
        <Row>
          <Col span={24}>
            <img
              src={`${organization.s3BucketBaseUrl}/OuterLogo.svg`}
              alt="Logo"
            />
          </Col>
        </Row>

        <Row className="mt2">
          <Col className="h1-header">Login with Mobile</Col>
        </Row>

        <Row className="mt2 mb2">
          <Col span={24}>
            <NicheSendOtp url={userSendOtpUrl} handleSubmit={handleSubmit} />
          </Col>
        </Row>
        <Row className="mt2 mb1 flex-center">
          <Col>
            <Link to="/login" title="Login via Email">
              <MailOutlined className="mr025" /> Login
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SendOtp;
